// The home page said "Good morning" at 5:21pm (2026-09-24). The browser's
// clock is the owner's clock, so the greeting reads it.
export function greetingFor(hour: number): string {
  if (hour >= 5 && hour < 12) return 'Good morning';
  if (hour >= 12 && hour < 17) return 'Good afternoon';
  return 'Good evening';
}
